/**
 * Registracija service workerja (P2 §8.5).
 *
 * ⚠️ **Samo v produkcijski gradnji.** Pod `vite dev` bi SW predpomnil module,
 * ki jih HMR sproti spreminja, in razvijalec bi gledal staro kodo brez
 * pojasnila. Pogoj je statičen, zato Vite v produkciji odstrani vejo, v
 * razvoju pa celotno telo.
 *
 * ⚠️ **Registracija čaka na `load`.** Prenos in namestitev SW tekmujeta z
 * zahtevki za prvi izris; brez čakanja hladen zagon upočasnita, namesto da bi
 * ga pospešila. Naslednji obisk je tisti, ki od SW kaj ima.
 *
 * Neuspeh je tih in **pravilno tih**: aplikacija brez SW deluje v celoti, le
 * brez povezave se ne odpre. Sporočilo o tem bi bilo o nečem, česar uporabnik
 * ni zahteval in ne more popraviti (P4 §5).
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    // Relativna pot, ker je `base: './'` (T1 §10): pod `capacitor://` bi se
    // absolutna zlomila.
    void navigator.serviceWorker.register('sw.js', { scope: './' }).catch(() => {});
  });
}
